import * as React from 'react';
const ListSubheaderContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== 'production') {
  ListSubheaderContext.displayName = 'ListSubheaderContext';
}
export default ListSubheaderContext;